import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Integration"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.4097 11.64L17.9097 3.39C17.7778 3.14889 17.5246 2.99925 17.2497 3H6.74974C6.4749 2.99925 6.22166 3.14889 6.08974 3.39L1.58974 11.64C1.45576 11.8721 1.45576 12.158 1.58974 12.39L6.08974 20.64C6.22937 20.8696 6.48114 21.0069 6.74974 21H17.2497C17.5246 21.0008 17.7778 20.8511 17.9097 20.61L22.4097 12.36C22.5325 12.1357 22.5325 11.8643 22.4097 11.64ZM17.1972 5.25L20.4897 11.25H13.3647L17.1972 5.25ZM11.9997 10.605L8.11474 4.5H15.8847L11.9997 10.605ZM6.80215 5.25L10.6346 11.25H3.50965L6.80215 5.25ZM3.50965 12.75H10.6346L6.80215 18.75L3.50965 12.75ZM11.9997 13.395L15.8847 19.5H8.11474L11.9997 13.395ZM17.1972 18.75L13.3647 12.75H20.4897L17.1972 18.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Integration.vue"]]);
